import './Presentation.css'

const Presentation = ({onClick, image, title, topic, other, description, available}) => {
    return (
        <div className={available ? 'presentation-container' : 'presentation-container not-available-presentation'}>
            <img className={available ? 'presentation-image' : 'presentation-image not-available-image'} src={image} alt='presentation-first-slide'></img>
            <div className='presentation-text-content'>
                <div className='presentation-title-topic-date-container'>
                    <div className='presentation-title-date-container'>
                        <span className='presentation-title'>{title}</span>
                    </div>
                    <span className='presentation-topic'>{topic === 'Other' ? other : topic}</span>
                </div>
                <span className='presentation-description'>{description}</span>
                <span 
                    className={available ? 'presentation-link' : 'not-available-link'} 
                    onClick={onClick}
                >
                    {available ? 'Watch Presentation' : 'Coming soon 🔥'}
                </span>
            </div>
        </div>
    )
}

export default Presentation